export default function retrains(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT_RETRAIN':
            return {
                ...state,
                retrain: action.retrain,
            }
        default:
            return state;
    }
}
